import type { AppErrorDetails } from './appErrorTypes';
import { persistAppError } from './appErrorStorage';
import { normalizeAppError } from './normalizeAppError';

export const APP_ERROR_PATH = '/error';

/**
 * Persist error and navigate to the app error page (full navigation — works outside React).
 */
export function reportAppError(
  error: unknown,
  overrides?: Partial<AppErrorDetails>,
): AppErrorDetails {
  const details = normalizeAppError(error, overrides);
  persistAppError(details);

  const path = `${APP_ERROR_PATH}?kind=${encodeURIComponent(details.kind)}`;
  if (typeof window !== 'undefined') {
    window.location.assign(path);
  }

  return details;
}

export function buildAppErrorLocationState(
  error: unknown,
  overrides?: Partial<AppErrorDetails>,
): { error: AppErrorDetails } {
  const details = normalizeAppError(error, overrides);
  persistAppError(details);
  return { error: details };
}
